import { Reducer } from 'redux';
import { KnownAction, SetUserCheckpointAction, UpdateUserCheckpointAction, UpdateStateCheckpointAction, KnownCheckpointStates, ResetCheckpointAction, EnableReplayCheckpointAction, DisableReplayCheckpointAction } from './CheckpointActions';
import CurrentDirectionType from "src/models/frontend/redux/CurrentDirectionType";
import CheckpointStatusDTO from "src/models/frontend/redux/CheckpointStatusDTO";

export class MissionState {
    public current: CheckpointStatusDTO;
    public furthest: CheckpointStatusDTO;

    /** Handles previous location when replay is activated/deactivated */
    public previous: CheckpointStatusDTO;
    /** Handles stop location when replay is activated */
    public replay: CheckpointStatusDTO;

    public state: KnownCheckpointStates;
    public currentDirection: CurrentDirectionType;
    public isReplayModeActive: boolean;

    constructor() {
        this.current = null;
        this.furthest = null;
        this.previous = null;
        this.replay = null;

        this.state = "none";
        this.currentDirection = "forwards";
        this.isReplayModeActive = false;
    }
}

export const MissionReducer: Reducer<MissionState> = (state: MissionState = new MissionState(), action: KnownAction) => {
    switch (action.type) {
        case "SET_CHECKPOINT":
            let setAction: SetUserCheckpointAction = action;
            if (setAction.data == null) {
                return { ...state };
            }

            return {
                ...state,
                current: setAction.data.current || state.current,
                previous: setAction.data.previous || state.previous,
                furthest: setAction.data.furthest || state.furthest,
                replay: setAction.data.replay || state.replay,
                currentDirection: setAction.data.currentDirection || state.currentDirection,
            };
        case "UPDATE_CHECKPOINT":
            let updateAction: UpdateUserCheckpointAction = action;
            if (updateAction.data == null) {
                return { ...state };
            }

            return {
                ...state,
                current: updateAction.data.current || state.current,
                furthest: updateAction.data.furthest || state.furthest,
                currentDirection: updateAction.data.currentDirection || state.currentDirection,
            };
        case "ENABLE_REPLAY_CHECKPOINT":
            let enableReplayAction: EnableReplayCheckpointAction = action;
            let newCurrent: CheckpointStatusDTO = {...enableReplayAction.data.start};
            let newReplay: CheckpointStatusDTO = {...enableReplayAction.data.end};
            let newPrevious: CheckpointStatusDTO = {...state.current};

            return {
                ...state,
                current: newCurrent,
                previous: newPrevious,
                replay: newReplay,
                isReplayModeActive: true
            };
        case "DISABLE_REPLAY_CHECKPOINT":
            let disableReplayAction: DisableReplayCheckpointAction = action;

            return {
                ...state,
                current: {...state.previous},
                previous: null,
                replay: null,
                isReplayModeActive: false
            };
        case "UPDATE_STATE_CHECKPOINT":
            let updateStateAction: UpdateStateCheckpointAction = action;
            return {
                ...state,
                state: updateStateAction.data
            };
        case "RESET_CHECKPOINT":
            let resetAction: ResetCheckpointAction = action;
            return new MissionState();
        default:
            // JB - Clarification: The following line is fucking magic
            const exhaustiveCheck: never = action;
    }

    // For unrecognized actions (or in cases where actions have no effect), must return the existing state
    //  (or default initial state if none was supplied)
    return state;
};



// WEBPACK FOOTER //
// ./src/redux/CheckpointReducer.ts